import React from 'react';
import { observable, action, Icon } from 'mobx';
import { getCaseDatas, getAllTags, findReadme } from '../../api/list';
import { message, notification } from 'antd';
import util from '../../util/index';
import base from '../../tool/base';
const {
  getAccessToken,
  isMobile,
  getTel,
} = util;

const initState = {
  loading: false,
  loadMore: false,
  caseList: [],
  pageNum: 1,
  pageSize: 6,
  count: 0,
  params: {
    pageNum: 1,
    pageSize: 8,
  },
  otherParams: {},
  searchFormValue: {
    title: "",
    tagId: "",
    demotype: "default",
    platform: "",
    orderby: "createdate",
  },
  tags: [],
  searchLoading: false,
  apply: {
    appId: '',
    title: '',
    ec: 'E9',
    applyType: 'temporary',
    authKey: '',
    kb: '',
  },
  applyVisible: false,
  applyDemoLoading: false,
  starsLoading: false,
  appList: [],
  appCount: 0,
  appLoading: false,
  isPermissions: false,
};

export class CaseListStore {

  routing = null;
  otherParams = initState.otherParams;

  @observable params = initState.params;
  @observable loading = initState.loading;
  @observable loadMore = initState.loadMore;
  @observable caseList = initState.caseList;
  @observable pageNum = initState.pageNum;
  @observable pageSize = initState.pageSize;
  @observable count = initState.count;
  @observable searchFormValue = initState.searchFormValue;
  @observable tags = initState.tags;
  @observable searchLoading = initState.searchLoading;
  @observable apply = initState.apply;
  @observable applyVisible = initState.applyVisible;
  @observable applyDemoLoading = initState.applyDemoLoading;
  @observable starsLoading = initState.starsLoading;
  @observable appList = initState.appList;
  @observable appCount = initState.appCount;
  @observable appLoading = initState.appLoading;

  @observable isPermissions = initState.isPermissions;

  constructor(routing) {
    this.routing = routing;
  }

  @action
  setState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }
  @action
  setOtherParams = (params = {}) => {
    this.otherParams = params;
    return this;
  }
  @action
  setApply = (params = {}) => {
    this.apply = {
      ...this.apply,
      ...params,
    }
  }
  @action
  initApply = () => {
    this.apply = initState.apply;
    this.isPermissions = initState.isPermissions;
  }

  @action
  initPage = () => {
    this.params = initState.params;
  }

  @action
  setStars = (params = {}) => {   //点赞
    params = {
      ...params,
      access_token: getAccessToken(),
    }
    this.starsLoading = true;
    return new Promise((resolve) => {
      base.callApi('/v5/ecode/thumbsupAdd', 'POST', params, 'json', 'text').then((data) => {
        if (data.status) {
          // data.msg === '已点赞' ? message.success(data.msg) : message.info(data.msg);
        } else {
          // message.error(data.msg);
        }
        this.starsLoading = false;
        resolve(data);
      });
    })
  }

  @action
  clear = () => this.setState(initState)

  @action
  clearSearchValue = () => this.setState({searchFormValue: initState.searchFormValue});

  @action
  getCaseList = async (params, loading = true)  => {
    this.loading = loading;
    const res = await getCaseDatas({
      ...this.params,
      ...this.otherParams,
      ...params,
      access_token: getAccessToken(),
    });
    try {
      if (res.status) {
        this.caseList = res.demoList;
        this.count = res.count;
        // this.pageNum = params.pageNum;
        // this.pageSize = params.pageSize;
      } else {
        console.error('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.error('接口错误：', e);
    }
    this.loading = false;
  }

  @action
  getCaseListAdd = async params => {
    this.loadMore = true;
    const res = await getCaseDatas({
      ...this.params,
      ...this.otherParams,
      ...params,
      access_token: getAccessToken(),
    });
    try {
      if (res.status) {
        this.caseList = this.caseList.length > 0 ? this.caseList.concat(res.demoList) : res.demoList;
        this.count = res.count;
        this.pageNum = params.pageNum;
        this.pageSize = params.pageSize;
      } else {
        console.log('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.log('接口错误：', e);
    }
    this.loadMore = false;
  }

  @action
  getAppList = async (params, loading = true)  => {
    this.appLoading = loading;
    const res = await getCaseDatas({
      ...params,
      caseType: 'app',
      access_token: getAccessToken(),
    });
    try {
      if (res.status) {
        this.appList = res.demoList;
        this.appCount = res.count;
      } else {
        console.log('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.log('接口错误：', e);
    }
    this.appLoading = false;
  }

  @action
  getVisitLog = async params => {
    const platform = isMobile() ? "mobile" : "pc";
    const logParams = {
      platform: platform,
      mobile: getTel(),
      ...params,
    };
    base.callApi('/v5/ecode/visitLog', 'POST', logParams, 'json', 'text').then((data) => {
      if (data.status) {
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }

  @action
  applyDemo = async params => {     //申请app
    this.applyDemoLoading = true;
    const logParams = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise((resolve) => {
      base.callApi(this.isPermissions ? "/v5/apply/applyDevAuth" : '/v5/apply/applyDemo', 'POST', logParams, 'json', 'text').then((data) => {
        this.applyDemoLoading = false;
        if (data.status) {
          // message.success(data.requestState);
          notification.open({
            message: '申请成功',
            description:
              <span>
                申请成功，导入应用请查看
                <a href="https://e-cloudstore.com/doc.html?appId=c2725f0d71304f83909146fa2151fc36" target="_blank">如何导入应用</a>
              </span>,
          });
        } else {
          // message.error( data.msg || '申请失败');
          notification.open({
            message: '申请失败',
            description: this.isPermissions ? data.msg : 
              <span>
                申请失败，请输入正确的
                <a href="https://e-cloudstore.com/doc.html?appId=2997bd5a45de474db8d34034db8b4bb0" target="_blank">授权码</a>
              </span>,
          });
        }
        resolve(data);
      }).catch(() => {
          message.error('申请失败');
        }
      );
    });
  }

  @action
  temporaryAuth = async (params, callback) => {  //申请开发权限
    const logParams = {
      ...params,
      access_token: getAccessToken(),
    };
    base.callApi('/v5/apply/temporaryAuth', 'POST', logParams, 'json', 'text').then((data) => {
      if (data.status) {
        callback(data);
      } else {
        message.error(data.msg || '申请失败');
      }
    }).catch(() => {
      message.error('申请失败');
    });
  }

  @action
  getTagsList = async params => {
    this.searchLoading = true;
    const res = await getAllTags();
    try {
      if (res.status) {
        this.tags = res.data;
      } else {
        console.log('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.log('接口错误：', e);
    }
    this.searchLoading = false;
  }
}


// WEBPACK FOOTER //
// ./src/stores/home/CaseListStore.js